import { createMedium, createSidecarMedium } from 'use-sidecar';
export var mediumFocus = createMedium({}, function (_ref) {
  var target = _ref.target,
      currentTarget = _ref.currentTarget;
  return {
    target: target,
    currentTarget: currentTarget
  };
});
export var mediumBlur = createMedium();
export var mediumEffect = createMedium();
export var mediumSidecar = createSidecarMedium({
  async: true
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-focus-lock/dist/es2015/medium.js
// module id = 226
// module chunks = 0